// src/context/SaveFlowContext.tsx
import React, { createContext, useContext, useState, useCallback, ReactNode } from "react";

interface SaveUserData {
  fullName: string;
}

interface SaveFlowContextType {
  // Funkcja zwraca Promise, który rozwiązuje się, gdy użytkownik kliknie "Zapisz" w modalu
  promptForUserData: () => Promise<SaveUserData | null>;
}

const SaveFlowContext = createContext<SaveFlowContextType | undefined>(undefined);

export const useSaveFlow = () => {
  const context = useContext(SaveFlowContext);
  if (!context) {
    throw new Error("useSaveFlow must be used within a SaveFlowProvider");
  }
  return context;
};

export const SaveFlowProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fullName, setFullName] = useState("");
  // Przechowujemy funkcję resolve z Promise'a
  const [resolvePromise, setResolvePromise] = useState<((value: SaveUserData | null) => void) | null>(null);

  const promptForUserData = useCallback(() => {
    setIsOpen(true);
    setFullName(""); // Reset pola
    return new Promise<SaveUserData | null>((resolve) => {
      setResolvePromise(() => resolve);
    });
  }, []);

  const handleConfirm = () => {
    if (!fullName.trim()) {
      alert("Proszę podać imię i nazwisko.");
      return;
    }
    if (resolvePromise) resolvePromise({ fullName });
    setIsOpen(false);
  };

  const handleCancel = () => {
    if (resolvePromise) resolvePromise(null); // Zwracamy null, co przerwie zapis
    setIsOpen(false);
  };

  return (
    <SaveFlowContext.Provider value={{ promptForUserData }}>
      {children}
      
      {/* --- MODAL --- */}
      {isOpen && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.8)", zIndex: 9999,
          display: "flex", alignItems: "center", justifyContent: "center"
        }}>
          <div style={{
            backgroundColor: "#ffffff", padding: "30px", borderRadius: "8px",
            width: "400px", maxWidth: "90%", textAlign: "center", color: "#333"
          }}>
            <h3 style={{marginTop: 0}}>Zapisywanie projektu</h3>
            <p>Podaj imię i nazwisko, abyśmy mogli zidentyfikować Twój projekt:</p>
            
            <input
              type="text"
              placeholder="Imię i Nazwisko"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              style={{
                width: "100%", padding: "10px", margin: "10px 0 20px 0",
                fontSize: "16px", borderRadius: "4px", border: "1px solid #ccc"
              }}
            />

            <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
              <button 
                onClick={handleCancel}
                style={{ padding: "10px 20px", cursor: "pointer", background: "#ccc", border: "none", borderRadius: "4px" }}
              >
                Anuluj
              </button>
              <button 
                onClick={handleConfirm}
                style={{ padding: "10px 20px", cursor: "pointer", background: "#4CAF50", color: "white", border: "none", borderRadius: "4px" }}
              >
                Zapisz i Generuj
              </button>
            </div>
          </div>
        </div>
      )}
    </SaveFlowContext.Provider>
  );
};